import React, { useState, useEffect } from "react";
import styles from "./EditGroup.module.css";
import AddGroup from "./AddGroup";
import EditGroupDetail from "./EditGroupDetail";
import { Group } from "../../../user/User";
import PuiTypography from "../../../components/elements/PuiTypography";
import DraggableList from "../../../common/components/draggableList/DraggableList";
import { useDispatch, useSelector } from "react-redux";
import { GetGroupList, GetUserInfoList, UpdateGroupList } from "../../../user/UserActions";
import { AppState } from "../../../root/RootReducer";
import { Button, CircularProgress, Modal } from "@material-ui/core";
import { t } from "i18next";
// import { isEmpty } from "../../../utils/ObjectUtils";

interface EditGroupProps {
    isSaved: boolean;
    setIsSaved: (isSaved: boolean) => void;
}

export default function EditGroup({ isSaved, setIsSaved }: EditGroupProps) {
    const dispatch = useDispatch();

    const { groupList, isLoading } = useSelector(({ user }: AppState) => user);

    // 更新・表示用のグループリスト
    // const [userGroupList, setUserGroupList] = useState<Group[]>();
    const [group, setGroup] = useState<Group>();
    const [groupId, setGroupId] = useState<string>();
    const [updateList, setUpdateList] = useState<Group[]>([]);
    const [backList, setBackList] = useState<Group[]>([]);

    // 制御パラメータ
    const [showDetail, setShowDetail] = useState<boolean>(false);
    const [inputFinished, setInputFinished] = useState<boolean>(true);
    const [showModal, setShowModal] = useState<boolean>(false);

    // メッセージ制御用
    // const [showMessage, setShowMessage] = useState<boolean>(false);
    // const [msgTitle, setMsgTitle] = useState<string>("");
    // const [msgDetail, setMsgDetail] = useState<ReactNode[]>([]);
    const [msgDetailMod, setMsgDetailMod] = useState<string[]>([]);
    // eslint-disable-next-line
    const [msgDetailAdd, setMsgDetailAdd] = useState<string[]>([]);
    // const [msgDetailDel, setMsgDetailDel] = useState<string[]>([]);

    //Addアイコンにマウス入る処理
    const [isMouseEnterInfo, setMouseEnterInfo] = useState<boolean>(false);

    //APIコール
    useEffect(() => {
        dispatch(GetGroupList());
    }, [dispatch]);

    // 更新用リストの初期化
    useEffect(() => {
        // setUserGroupList(groupList);
        setUpdateList(groupList);
    }, [groupList]);

    // Listner
    useEffect(() => {
        setBackList(updateList);
    }, [updateList, backList]);

    // グループ作成画面を開く
    const handleOpenModal = () => {
        setShowModal(true);
    };
    // グループ作成画面を閉じる
    const handleCloseModal = (item: Group) => {
        if (!item || !item?.title) return setShowModal(false);

        // if (!isEmpty(item)) {
        setUpdateList([...updateList, item]);
        setIsSaved(false);
        if (!msgDetailAdd.includes(item.title)) {
            setMsgDetailAdd([...msgDetailAdd, item.title]);
        }
        // }
        setShowModal(false);
    };

    // グループリスト項目押下時、押下されたグループの詳細を表示する
    const onClickGroup = (targetId: string) => {
        if (targetId === groupId || !inputFinished) {
            return null;
        }

        const selectedGroup = updateList.filter((group) => String(group.id) === targetId)[0];
        setGroup(selectedGroup);
        setGroupId(selectedGroup.id);
        setShowDetail(true);
    };

    // ユーザのリストの削除、並び替え時にコールされる
    const onUpdate = (targetId: string, targetList: any) => {
        // 更新リスト
        setUpdateList(targetList);
        setIsSaved(false);
    };

    // 更新ボタン押下
    const handleUpdateGroup = () => {
        dispatch(UpdateGroupList(updateList));
        setGroupId("");
        setShowDetail(false);
        setIsSaved(true);
        dispatch(GetUserInfoList());
        // setShowMessage(true);
    };

    // Group更新時のメッセージ関連処理
    const handleEditGroup = (title: string) => {
        if (msgDetailAdd.includes(title)) {
            return;
        }

        if (!msgDetailMod.includes(title)) {
            setMsgDetailMod([...msgDetailMod, title]);
        }
    };

    // 表示待機
    if (isLoading) {
        return (
            <div className={styles.noContent}>
                <CircularProgress size={60} style={{ color: "var(--loading-bg)" }} />
            </div>
        );
    }

    return (
        <div className={styles.root}>
            {/* グループリスト */}
            <div className={styles.left}>
                {updateList !== undefined && (
                    <div>
                        <div className={styles.listTitle}>
                            <PuiTypography size={24} color={"white"}>
                                {t("グループ一覧")}
                            </PuiTypography>
                        </div>
                        <div className={styles.groupList}>
                            <DraggableList
                                type="groupList"
                                currentId={groupId}
                                targetList={updateList}
                                onClick={onClickGroup}
                                onUpdate={onUpdate}
                                showListNum={8}
                            />
                            <div
                                onMouseEnter={() => setMouseEnterInfo(true)}
                                onMouseLeave={() => setMouseEnterInfo(false)}
                                style={{ textAlign: "center" }}
                            >
                                {!isMouseEnterInfo && (
                                    <img
                                        style={{
                                            cursor: "pointer",
                                            textAlign: "center",
                                        }}
                                        alt={"More"}
                                        onClick={handleOpenModal}
                                        src={
                                            require("../../../../src/assets/image/MoreIcon.svg")
                                                .default
                                        }
                                    />
                                )}
                                {isMouseEnterInfo && (
                                    <img
                                        style={{
                                            cursor: "pointer",
                                            textAlign: "center",
                                        }}
                                        alt={"More"}
                                        onClick={handleOpenModal}
                                        src={
                                            require("../../../../src/assets/image/MoreIcon_hover.svg")
                                                .default
                                        }
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.middle}>
                {showDetail && (
                    <EditGroupDetail
                        group={group}
                        updateList={updateList}
                        setUpdateList={setUpdateList}
                        setInputFinished={setInputFinished}
                        setIsSaved={setIsSaved}
                        handleEditGroup={handleEditGroup}
                    />
                )}
            </div>

            <Modal open={showModal} onClose={handleCloseModal}>
                <>
                    <AddGroup onClose={handleCloseModal} />
                </>
            </Modal>
            <div className={styles.updateButton}>
                {isSaved && inputFinished ? (
                    <Button
                        disabled={isSaved}
                        type="submit"
                        onClick={handleUpdateGroup}
                        color="secondary"
                        className={styles.addButton}
                        style={{
                            color: "var(--loading-bg)",
                            fontSize: "16px",
                            fontFamily: "noto-sans-cjk-jp,sans-serif",
                            backgroundColor: "var(--button-bg)",
                        }}
                    >
                        {t("更新")}
                    </Button>
                ) : (
                    <Button
                        type="submit"
                        onClick={handleUpdateGroup}
                        color="secondary"
                        className={styles.addButton}
                        style={{
                            color: "white",
                            fontSize: "16px",
                            fontWeight: "bold",
                            fontFamily: "noto-sans-cjk-jp,sans-serif",
                            backgroundColor: "var(--studio-btn-bg)",
                        }}
                    >
                        {t("更新")}
                    </Button>
                )}
            </div>
        </div>
    );
}
